import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["card", "row", "count"]
  static values = { label: { type: String, default: "Matches" } }

  filter(event) {
    const category = event.params.category
    const isActive = this.activeCategory === category

    this.activeCategory = isActive ? null : category

    this.cardTargets.forEach(card => {
      if (!isActive && card.dataset.reportFilterCategoryParam === category) {
        card.classList.add("ring-2", "ring-blue-500")
      } else {
        card.classList.remove("ring-2", "ring-blue-500")
      }
    })

    let visible = 0
    this.rowTargets.forEach(row => {
      const categories = row.dataset.reportFilterCategories.split(" ")
      if (this.activeCategory && !categories.includes(this.activeCategory)) {
        row.classList.add("hidden")
      } else {
        row.classList.remove("hidden")
        visible++
      }
    })

    if (this.hasCountTarget) {
      const total = this.rowTargets.length
      const label = this.labelValue
      this.countTarget.textContent = this.activeCategory
        ? `${label} (${visible}/${total})`
        : `${label} (${total})`
    }
  }
}